import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface UnsavedChangesModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

/**
 * UnsavedChangesModal - Confirmation dialog before leaving with unsaved changes
 * Now supports optional customization for overwrite confirmation use case
 */
export const UnsavedChangesModal = ({
  isOpen,
  onConfirm,
  onCancel,
  title = 'Unsaved changes',
  message = 'You have unsaved changes. Are you sure you want to leave this page?',
  confirmLabel = 'Leave',
  cancelLabel = 'Stay',
}: UnsavedChangesModalProps) => {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={open => {
        if (!open) onCancel();
      }}
    >
      <DialogContent
        aria-describedby={undefined}
        className="bg-chariot-background-primary border-chariot-stroke max-w-md rounded-lg border p-6 [&>button]:hidden"
      >
        <DialogHeader>
          <DialogTitle className="text-chariot-text-primary text-lg font-semibold">
            {title}
          </DialogTitle>
        </DialogHeader>

        <div className="mt-4 space-y-2">
          <p className="text-chariot-text-secondary text-sm">{message}</p>
        </div>

        <DialogFooter className="mt-6">
          <Button variant="outline" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
